import React, {useEffect, useRef, useState} from "react";
import {Toast} from "primereact/toast";
import {AutoComplete} from "primereact/autocomplete";
import {ContainerGroupForm} from "../Containers/ContainerGroupForm";
import {anios, meses} from "../../shared/types/constantes";
import {UsePermissions} from "../../hooks/usePermissions";
import {arrayNum, convertirModena} from "../../shared/utils/utils";
import {getClients, getContractByClient} from "../../api/factura.service";
import {UseLoader} from "../../hooks/useLoader";
import {traerInformeCompensacion} from "../../api/informes.service";
import {InformeCompensacionEvento} from "./components/compensacion/InformeCompensacionEvento";

export const InformeCompensacion = () => {
    const [handleLoad] = UseLoader();
    const toast = useRef(null);
    const [permisos] = UsePermissions();
    const [clientes, setClientes] = useState([]);
    const [FilteredCliente, setFilteredCliente] = useState(null);
    const [dataLiquidacion, setDataLiquidacion] = useState({
        factura: {
            cliente_id: "",
            contratomarco_id: "",
            factura_id: "",
            num_factura: "",
            valor_neto: "",
            valor_descuento: "",
            valor_factura: "",
            porcentaje: "",
            valor_admon:"",
            sub_total_dos:"",
            valor_compensacion:"",
            valor_prestaciones:""
        },
        data: [],
        datosFacturaLiq: []

    });

    const [selectedcliente, setSelectedcliente] = useState({
        id: "",
        nombre: "",
        tipo: ""
    });

    const [selectedContract, setSelectedContract] = useState(null);
    const [contratos, setContratos] = useState([]);
    const [FilteredContratos, setFilteredContratos] = useState(null);

    //console.log('Cliente: ',selectedcliente);
    const initParams = {
        anio: "",
        mes: "",
        periodo: "",
        cliente_id: '',
    };
    const [field, setField] = useState(initParams);
    const periodo = arrayNum(50);

    useEffect(() => {
        getClients().then(r => {
            if (r.estado !== 200) {
                return;
            }
            setClientes(r.data)
        }).catch(r => console.log(r))
        return () => {
            if (clientes.length > 0) {
                setClientes([]);
            }
        };
    }, []);

    useEffect(() => {
        if (selectedcliente.id !== '') {
            getContractByClientPromise(selectedcliente.id)
        }
    }, [selectedcliente.id]);

    const searchContrato = (event) => {
        setTimeout(() => {
            let _filteredCliente;
            if (!event.query.trim().length) {
                _filteredCliente = [...contratos];
            } else {
                _filteredCliente = contratos.filter((contrato) => {
                    return contrato.codigo.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredContratos(_filteredCliente);
        }, 250);
    }

    const searchCliente = (event) => {
        setTimeout(() => {
            let _filteredCliente;
            if (!event.query.trim().length) {
                _filteredCliente = [...clientes];
            } else {
                _filteredCliente = clientes.filter((cliente) => {
                    return cliente.nombre.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCliente(_filteredCliente);
        }, 250);
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex ">
                <div className="ml-3">{item.nombre}</div>
            </div>
        );
    }

    const itemTemplateContrat = (item) => {
        return (
            <div className="flex ">
                <div className="ml-3">{item.codigo}</div>
            </div>
        );
    }

    const getContractByClientPromise = (clienteId) => {
        if (clienteId !== "") {
            getContractByClient({
                cliente_id: clienteId
            }).then(r => {
                if (r.data.length === 0) {
                    setContratos([])
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: "No se encontraron contratos para el cliente seleccionado",
                        life: 3000
                    });
                    return
                }

                setContratos(r.data)
            });
        }
    }

    const buscarInfoFacturaReload = async () => {
        try {
            for (let f in field) {
                if (field[f] === '') {
                    if (f === 'anio') f = 'Año';
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: `El campo ${f} es obligatorio`,
                        life: 3000
                    });
                    return;
                }
            }
            handleLoad(true);

            const response = await traerInformeCompensacion(field);
            handleLoad(false);
            if (response.estado !== 200) {
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                return;
            }

            setDataLiquidacion(response)
            //console.log('Data', dataLiquidacion);

        } catch (e) {
            handleLoad(false);
            console.log(e)
        }
    }

    const buscarInfoFactura = async (e) => {

        e.preventDefault();
        try {
            for (let f in field) {
                if (field[f] === '') {
                    if (f === 'anio') f = 'Año';
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: `El campo ${f} es obligatorio`,
                        life: 3000
                    });
                    return;
                }
            }
            handleLoad(true);

            const response = await traerInformeCompensacion(field);
            handleLoad(false);
            if (response.estado !== 200) {
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                return;
            }

            setDataLiquidacion(response)
            //console.log('Data1', dataLiquidacion);

        } catch (e) {
            handleLoad(false);
            console.log(e)
        }
    }

    return(
        <>
            <Toast ref={toast}/>

            {/*Titulo*/}
            <h6 className="title-modal" id="turno">
                Turnos por asociados factura
            </h6>

            {/*Filtros De Busqueda*/}
            <div className=" flex flex-wrap items-center  p-4 primary-color">
                {permisos.consultar === 1 && clientes.length > 0 ?
                    <div className=" mt-2 relative lg:w-3/12 px-4">
                        <AutoComplete value={selectedcliente} suggestions={FilteredCliente}
                                      style={{"width": "100%"}}
                                      completeMethod={searchCliente}
                                      placeholder="Buscador clientes"
                                      size="30"
                                      field="nombre" dropdown itemTemplate={itemTemplate}
                                      onSelect={(e) => setField({...field, cliente_id: e.value.id})}
                                      onChange={(e) => setSelectedcliente(e.value)}/>
                    </div>
                    : ""}

                { permisos.consultar === 1 && selectedcliente.id !== "" && contratos.length > 0  ?
                    <div className=" mt-2 relative lg:w-3/12 px-4">
                        <AutoComplete value={selectedContract} suggestions={FilteredContratos}
                                      completeMethod={searchContrato}
                                      style={{width: "100%"}}
                                      placeholder="Buscador contrato"
                                      size="30"
                                      field="codigo" dropdown itemTemplate={itemTemplateContrat}
                                      onSelect={(e) => setField({...field, contratomarco_id: e.value.id})}
                                      onChange={(e) => setSelectedContract(e.value)}/>
                    </div> : ''}

                <div className=" mt-2 relative lg:w-6/12 px-4">
                    <form onSubmit={buscarInfoFactura}>
                        <div className="row">
                            <ContainerGroupForm width="lg:w-3/12">
                                <label
                                    className="label-form text-white"
                                    htmlFor="anio"
                                >
                                    Año *
                                </label>
                                <select value={field.anio} name="periodo"
                                        className="form-input"
                                        onChange={(e) => setField({...field, anio: e.target.value})}
                                        id="anio">
                                    <option value="">...</option>
                                    {anios.map((p, i) => <option key={i} value={p}>{p}</option>)}
                                </select>

                            </ContainerGroupForm>
                            <ContainerGroupForm width="lg:w-3/12">
                                <label
                                    className="label-form text-white"
                                    htmlFor="mes"
                                >
                                    Mes *
                                </label>
                                <select value={field.mes} name="mes"
                                        className="form-input"
                                        onChange={(e) => setField({...field, mes: e.target.value})}
                                        id="periodo">
                                    <option value="">...</option>
                                    {meses.map((p, i) => <option key={i} value={p.value}>{p.name}</option>)}
                                </select>


                            </ContainerGroupForm>
                            <ContainerGroupForm width="lg:w-3/12">
                                <label
                                    className="label-form text-white"
                                    htmlFor="periodo"
                                >
                                    Periodo *
                                </label>
                                <select value={field.periodo} name="periodo"
                                        className="form-input"
                                        onChange={(e) => setField({...field, periodo: e.target.value})}
                                        id="periodo">
                                    <option value="">...</option>
                                    {periodo.map((p, i) => <option key={i} value={p}>{p}</option>)}
                                </select>


                            </ContainerGroupForm>
                            <ContainerGroupForm width="lg:w-3/12">
                                <div className="mt-6 relative w-full px-4">
                                    <button
                                        className="warning-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Buscar
                                    </button>
                                </div>

                            </ContainerGroupForm>
                        </div>
                    </form>
                </div>
            </div>

            {/*Datos Factura*/}
            <div className=" lg:w-6/12 mt-3 px-4">
                <div className="container-relative">
                    <table className="items-center w-full bg-transparent border-collapse">
                        <thead>
                        <tr>
                            <th className={
                                "px-5 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color"
                            }>Concepto</th>
                            <th className={
                                "px-5 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color" }>Valor</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className="px-4 align-middle  text-sm whitespace-nowrap p-2 text-left items-center font-bold  border-gray-500 border-solid">Codigo Factura:</td>
                            <td className="px-4 align-middle  text-sm whitespace-nowrap p-2 text-left items-center border-gray-500 border-solid">{dataLiquidacion.data.num_factura}</td>
                        </tr>
                        <tr>
                            <td className="px-4 align-middle  text-sm whitespace-nowrap p-2 text-left items-center font-bold  border-gray-500 border-solid">Valor Facturado:</td>
                            <td className="px-4 align-middle  text-sm whitespace-nowrap p-2 text-left items-center border-gray-500 border-solid">{convertirModena(dataLiquidacion.data.valor_factura)}</td>
                        </tr>
                        <tr>
                            <td className= "px-4 align-middle  text-sm whitespace-nowrap p-2 text-left items-center font-bold  border-gray-500 border-solid">Gastos factura:</td>
                            <td className="px-4 align-middle  text-sm whitespace-nowrap p-2 text-left items-center border-gray-500 border-solid">{convertirModena(dataLiquidacion.data.valor_descuento)}</td>
                        </tr>
                        <tr>
                            <td className= "px-4 align-middle  text-sm whitespace-nowrap p-2 text-left items-center font-bold  border-gray-500 border-solid">Subtotal:</td>
                            <td className="px-4 align-middle  text-sm whitespace-nowrap p-2 text-left items-center border-gray-500 border-solid">{convertirModena(dataLiquidacion.data.valor_neto)}</td>
                        </tr>
                        <tr>
                            <td className="px-4 align-middle  text-sm whitespace-nowrap p-2 text-left items-center font-bold  border-gray-500 border-solid">Administración:</td>
                            <td className="px-4 align-middle  text-sm whitespace-nowrap p-2 text-left items-center border-gray-500 border-solid">{convertirModena(dataLiquidacion.data.valor_admon)}</td>
                        </tr>
                        <tr>
                            <td className= "px-4 align-middle  text-sm whitespace-nowrap p-2 text-left items-center font-bold  border-gray-500 border-solid">Subtotal:</td>
                            <td className="px-4 align-middle  text-sm whitespace-nowrap p-2 text-left items-center border-gray-500 border-solid">{convertirModena(dataLiquidacion.data.sub_total_dos)}</td>
                        </tr>
                        <tr>
                            <td className="px-4 align-middle  text-sm whitespace-nowrap p-2 text-left items-center font-bold  border-gray-500 border-solid">Compensación 80%:</td>
                            <td className="px-4 align-middle  text-sm whitespace-nowrap p-2 text-left items-center border-gray-500 border-solid">{convertirModena(dataLiquidacion.data.valor_compensacion)}</td>
                        </tr>
                        <tr>
                            <td className="px-4 align-middle  text-sm whitespace-nowrap p-2 text-left items-center font-bold  border-gray-500 border-solid">Prestaciones 20%:</td>
                            <td className="px-4 align-middle  text-sm whitespace-nowrap p-2 text-left items-center border-gray-500 border-solid">{convertirModena(dataLiquidacion.data.valor_prestaciones)}</td>
                        </tr>

                        </tbody>
                    </table>
                </div>
            </div>

            {/*Datos Asociados*/}
            <div className="container-relative">
                { /*{selectedcliente.tipo === 'E' || selectedcliente.tipo === 'H' && <InformeCompensacionEvento dataInicial={field} dataFactura={dataLiquidacion.data} dataAsociados={dataLiquidacion.dataAsociados} reload={buscarInfoFacturaReload}/> } */ }
                { <InformeCompensacionEvento dataInicial={field} dataFactura={dataLiquidacion.data} dataAsociados={dataLiquidacion.dataAsociados} reload={buscarInfoFacturaReload}/> }
            </div>

        </>
    )
}
